/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:42 2018/11/13
 */
import * as Vue from 'vue-tsx-support';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import FrameContentBg from 'src/pages/layout/components/frameContentBg';
import { createBEM } from 'src/util/bem';
import './tendencyManage.less';
import QueryForm, { QueryFormVOI } from 'src/components/queryForm/queryForm';
import ECharts from 'vue-echarts';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import DatePicker from 'src/types/iview/DatePicker';
import StationDetailApi, { StationDetailDOI } from '../api/stationDetailApi';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import LocalStore from 'src/util/LocalStore';
let bem = createBEM('tendency-manage');
@Component({
    name: 'tendency-manage',
})
export default class TendencyManage extends Vue.Component<any> {
    mn: string = '';
    divisors: any = [];
    undergroundWaterQueryFrom: QueryFormVOI.DateItemType[] = [
        {
            component: CommonSelect,
            label: '数据类型',
            field: 'cn',
            width: 250,
            props: {
                value: 2011,
                initValue: 2011,
                clearable: false,
                dataSource: [{ name: '测量数据', id: 2011 }],
            },
        },
        {
            component: DatePicker,
            label: '时间',
            field: 'time',
            width: 360,
            realField: ['start_time', 'end_time'],
            timeType: 'number',
            props: { value: DateTimeUtil.getDayInterval(), type: 'datetimerange', placeholder: '请选择时间' },
        },
    ];
    queryFrom: QueryFormVOI.DateItemType[] = [
        {
            component: CommonSelect,
            label: '数据类型',
            field: 'cn',
            width: 250,
            props: {
                value: 2061,
                initValue: 2061,
                clearable: false,
                dataSource: [{ name: '小时数据', id: 2061 },{ name: '实时数据', id: 2011 }, { name: '天数据', id: 2031 }],
            },
        },
        {
            component: DatePicker,
            label: '时间',
            field: 'time',
            width: 360,
            realField: ['start_time', 'end_time'],
            timeType: 'number',
            props: { value: DateTimeUtil.getDayInterval(), type: 'datetimerange', placeholder: '请选择时间' },
        },
    ];
    
    deviceType: Number = 0;
    series: any[] = [];

    singleLine: boolean = false;
    loading: boolean = false;
    type: string = 'line';
    get seriesGroup() {
        return this.singleLine ?  this.series.map(i => [i]) : [this.series];
    }

    created() {
        this.deviceType = parseInt(this.$route.query.type);
    }

    async search() {
        this.loading = true
        let obj: StationDetailDOI.QueryTrendencyMonitoringParamsI = (this.$refs.queryForm as QueryForm).getQueryObj();
        let { data, code } = await StationDetailApi.searchTrendencyMonitoring({
            ...obj,
            mn: this.mn,
            page_index: 1,
            page_size: 10000000,
        });
        this.loading = false
        if (code === 0) {
            this.divisors = data.header;
            let series: any[] = data.header.map(i => {
                let allData: any = data.body.map(j => ({
                    name: j.DateTime,
                    value: [j.DateTime, +j[i.key]],
                }));
                //判断上下限
                let alarm_ceiling = -1; //下限
                let alarm_floor = -1;  //上限
                data.alarm.map(a =>{
                    var aaaa = i.key
                    var bbbb  = a.key + "-Avg"
                    if (i.key === a.key + "-Avg") {
                        if (a.alarm_ceiling != null && a.alarm_ceiling != 0) {
                            alarm_ceiling = a.alarm_ceiling;
                        }
                        if (a.alarm_floor != null) {
                            alarm_floor = a.alarm_floor;
                        }
                        return
                    }
                });
                return {
                    name: i.name,
                    type: 'line',
                    smooth: true,
                    data: allData,
                    markLine:{ 
                        symbol:"none",
                        silent: true,
                        data: [
                            {
                              yAxis: alarm_ceiling,
                              lineStyle:{
                                //    type:"solid",
                                   width:2
                                },
                            },
                            {
                              yAxis: alarm_floor,
                              lineStyle:{
                                //    type:"solid",
                                   width:2
                                },
                            }
                        ]
                    }
                };
            });
            console.log('series', series);
            this.series = series;
        }
    }
    mounted() {
        this.mn = this.$route.query.mn;
        this.search();
        Bus.$on(Events.StationChange, this.stationChange);
    }
    stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn;
        this.search();
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
    }

    @Watch('type')
    typeChange() {
        this.search();
    }

    render(h) {
        return (
            <div class={bem()}>
                <QueryForm ref="queryForm" dataSource={this.deviceType == 2 ? this.undergroundWaterQueryFrom : this.queryFrom} on-search={this.search.bind(this)} showClear={false} />
                <FrameContentBg loading={this.loading}>
                    <div style="width: 100%;height: 100%;position: relative;">
                        <div class={bem('change-icon')}>
                            <div class={bem('change-icon-top')}>
                                <i class={{'wqms-font icon-duoquxian': true, 'active': !this.singleLine}} onClick={() => (this.singleLine = false)} />
                                <i class={{'wqms-font icon-danquxian': true, 'active': this.singleLine}} onClick={() => (this.singleLine = true)} />
                            </div>
                            <div class={bem('change-icon-buttom')}>
                                <radio-group v-model={this.type}>
                                    <radio size="large" label="line">
                                        曲线图展示
                                    </radio>
                                    <radio size="large" label="bar">
                                        柱状图展示
                                    </radio>
                                </radio-group>
                            </div>
                        </div>
                        {this.seriesGroup.map((i, index) => {
                            return <Charts key={index+ +this.singleLine} divisors={this.divisors} series={i} needChange={true} mn={this.mn} type={this.type}/>;
                        })}
                    </div>
                    {/* <div style="position: absolute;top:50px;right:10px">
                        <radio-group v-model={this.type}>
                            <radio size="large" label="line">
                                曲线图展示
                            </radio>
                            <radio size="large" label="bar">
                                柱状图展示
                            </radio>
                        </radio-group>
                    </div> */}
                </FrameContentBg>
            </div>
        );
    }
}

@Component
class Charts extends Vue.Component<any> {
    @Prop({
        type: Array,
    })
    series!: any;

    @Prop({
        type: Array,
    })
    divisors!: any;

    @Prop({
        type: Boolean,
    })
    needChange!: boolean;

    @Prop({
        type: String,
    })
    mn!: string;

    @Prop({
        type: String,
    })
    type!: string;

    // type: string = 'line';
    selectedArray = new Object();

    get option() {
        this.selectChange();
        let t = this;
        let series = this.series
        if (this.needChange) {
            series = series.map(i=> {
                return {...i, type: this.type, connectNulls: true}
            })
        }
        let start = 0
        try {
            let data = series[0].data
            let range = +new Date(data[data.length - 1].name) -  +new Date(data[0].name)
            range = Math.abs(range/1000)
            if(range - 24*60*60 > 0) {
                start = (range - 24*60*60)/range*100
            }
        } catch (error) {
            
        }
        return {
            color: ['#f45904', '#02fb71', '#419fff', '#effb29','#00c9db','#facd89','#f19ec2','#9eadf7','#e4007f','#ff00ff'],
            title: {
                text: '',
                textStyle: {
                    fontSize: 22,
                    color: '#fff',
                },
                left: 20,
                top: 15,
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter(params) {
                    return [
                        `<span>${params[0].data.name}</span>`,
                        ...params.map(i => {
                            let unit = t.divisors.find(divisor => {
                                return i.seriesName === divisor.name;
                            })!.unit;
                            return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                                i.color
                            };"></span>${i.seriesName}：${i.value[1]}${unit}`;
                        }),
                    ].join('<br/>');
                },
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: start,
                    end: 100,
                },
                {
                    start: start,
                    end: 100,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#419FFF',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                        borderColor: '#419FFF',
                    },
                    fillerColor: 'rgba(65,159,255,0.5)',
                    backgroundColor: 'rgba(65,159,255,0.3)',
                    borderColor: '#419FFF',
                    textStyle: {
                        color: '#fff',
                    },
                },
            ],
            legend: {
                data: series.map(i => i.name),
                textStyle: {
                    fontSize: 16,
                    color: '#fff',
                },
                top: 15,
                padding:[0,150,0,20],
                type: 'scroll',
                pageIconColor: '#fff',
                pageTextStyle:{
                    color: '#fff',
                },
                selected: this.selectedArray
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '50',
                top: 80,
                containLabel: true,
            },
            xAxis: {
                type: 'time',
                axisLabel: {
                    color: '#C3EBFF',
                    fontSize: 16,
                },
                axisLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                    },
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                        opacity: 0.2,
                    },
                },
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    color: '#02FB71',
                    fontSize: 16,
                },
                axisLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                        opacity: 0.2,
                    },
                },
            },
            series: series,
        };
    }

    selectChange() {
        let legendInfo = LocalStore.getData(this.mn + '_legendInfo');
        this.selectedArray = legendInfo;
    }

    mounted() {
        const myChart = this.$refs.myChart as ECharts;
        var chart = myChart.chart;
        chart.on('legendselectchanged', (params) => {
            var selected = params['selected'];
            LocalStore.clearData(this.mn + '_legendInfo');
            LocalStore.setData(this.mn + '_legendInfo', selected);
        });
    }

    render(h) {
        return (
            <div style="width: 100%;height: 100%;position: relative;">
                <ECharts ref="myChart" style="width: 100%;height: 100%;" options={this.option} auto-resize={true} />
            </div>
        );
    }
}
